// extracted by mini-css-extract-plugin
export default {"header":"AppDashboard_header__cVsl-","tabContainer":"AppDashboard_tabContainer__HSegL","tableContainer":"AppDashboard_tableContainer__oyh+N"};